import { SvgIcon, SvgIconProps } from '@mui/material'
import { FC } from 'react'

export const LearnIcon: FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.60722 16.4166C6.29055 15.6833 7.33223 15.7416 7.93223 16.5416L8.77389 17.6666C9.44889 18.5583 10.5406 18.5583 11.2156 17.6666L12.0572 16.5416C12.6572 15.7416 13.6989 15.6833 14.3822 16.4166C15.8656 18 17.0739 17.475 17.0739 15.2583V5.86663C17.0739 2.50829 16.2906 1.66663 13.1406 1.66663H6.84056C3.69056 1.66663 2.90723 2.50829 2.90723 5.86663V15.25C2.91556 17.475 4.13222 17.9916 5.60722 16.4166Z"
        stroke="#475569"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.70801 8.33337H12.2913"
        stroke="#475569"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  )
}
